export * from './config';
export * from './interfaces';
export * from './services';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/api/index.ts